import type { DropdownOption } from '../components/common/Dropdown';



export const normalizeRatingToDropdown = (items: any[] | undefined): DropdownOption[] => {
  if (!Array.isArray(items)) return [] as DropdownOption[];
  return items.map((it: any) => {
    const id = it?.RATING_ID ?? it?.value ?? it?.code ?? it?.key ?? '';
    const label = it?.RATING ? `${it?.RATING_ID} ${it?.RATING}` : '';
    const value = (it?.RATING ?? id ?? '') as string | number;
    return { id, label: String(label), value: String(value) } as DropdownOption;
  });
};

export const normalizeIdeaToDropdown = (items: any[] | undefined): DropdownOption[] => {
  if (!Array.isArray(items)) return [] as DropdownOption[];
  return items.map((it: any) => {
    const id = it?.TESTSOURCE_ID ?? it?.value ?? it?.code ?? it?.key ?? '';
    const label = it?.TESTSOURCE_DESC ? `${it?.TESTSOURCE_ID} ${it?.TESTSOURCE_DESC}` : '';
    const value = (it?.TESTSOURCE_DESC ?? id ?? '') as string | number;
    return { id, label: String(label), value: String(value) } as DropdownOption;
  });
};


export const normalizeShiftToDropdown = (items: any[] | undefined): DropdownOption[] => {
  if (!Array.isArray(items)) return [] as DropdownOption[];
  return items.map((it: any) => {
    const id = it?.SHIFT ?? '';
    const valueFallback = it?.SHIFT_NAME ?? it?.SHIFT ?? '';
    const labelFallback = it?.SHIFT_NAME ?? it?.SHIFT ?? '';
    const value = String(valueFallback);
    const label = String(labelFallback);
    return { id, label, value } as DropdownOption;
  });
};

export default normalizeShiftToDropdown;
